// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"afef04a8","463":"5862b6bd","977":"a83b5b4b"}[chunkId] + ".chunk.js";
};